import React from 'react';

import { Fab, Typography } from '@mui/material';

import { ReactComponent as FeedbackIcon } from '../../common/assets/icons/feedback_smile.svg';

const FeedbackButton: React.FC = () => {
  return (
    <Fab
      sx={{
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
        borderRadius: '15px',
        backgroundColor: 'white',
      }}
      onClick={(e) => {
        window.location.href = 'mailto:support@galeai.co';
        e.preventDefault();
      }}
      variant='extended'
      size='medium'
    >
      <FeedbackIcon />
      <Typography sx={{ ml: '15px' }} color='primary'>
        Feedback
      </Typography>
    </Fab>
  );
};

export default FeedbackButton;
